import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const PUBLIC_URL =
  (import.meta as any).env?.NEXT_PUBLIC_SUPABASE_URL ||
  process.env.NEXT_PUBLIC_SUPABASE_URL ||
  "";
const PUBLIC_KEY =
  (import.meta as any).env?.NEXT_PUBLIC_SUPABASE_KEY ||
  process.env.NEXT_PUBLIC_SUPABASE_KEY ||
  "";

// ABILITAZIONE CORRETTA: Supabase deve essere abilitato sul server (Node)
// e nel browser (window). Rimuoviamo la condizione 'typeof window !== "undefined"'
export const SUPABASE_ENABLED = Boolean(
  PUBLIC_URL && PUBLIC_KEY
);

let client: SupabaseClient | null = null;

export const supabase: SupabaseClient | null = SUPABASE_ENABLED
  ? (client = createClient(String(PUBLIC_URL), String(PUBLIC_KEY)))
  : null;

export function getSupabaseClient() {
  // Questa funzione può essere usata dal frontend per ottenere il client solo se abilitato
  return supabase;
}